// extracted by mini-css-extract-plugin
export var articleBody = "CommonQuestions-module--article-body--847e2";
export var articleHeader = "CommonQuestions-module--article-header--425e1";
export var articleSection = "CommonQuestions-module--article-section--e3bd0";
export var articleSummary = "CommonQuestions-module--article-summary--2b947";
export var bodyCopy = "CommonQuestions-module--body-copy--0ebf1";
export var codeRedArticleBody = "CommonQuestions-module--code-red-article-body--761bb";
export var codeRedRelatedArticleSection = "CommonQuestions-module--code-red-related-article-section--0da4e";
export var commonQuestionsSection = "CommonQuestions-module--common-questions-section--16727";
export var ctaSection = "CommonQuestions-module--cta-section--4b9ec";
export var firstSectionHeader = "CommonQuestions-module--first-section-header--e2e21";
export var header = "CommonQuestions-module--header--b6382";
export var iconContainer = "CommonQuestions-module--icon-container--05d15";
export var iconWrapper = "CommonQuestions-module--icon-wrapper--0cdb4";
export var lastArticle = "CommonQuestions-module--last-article--85833";
export var lastSection = "CommonQuestions-module--last-section--c5657";
export var questionSection = "CommonQuestions-module--question-section--ae547";
export var relatedArticleLinks = "CommonQuestions-module--related-article-links--86d5b";
export var relatedArticleSection = "CommonQuestions-module--related-article-section--fa8f4";
export var sectionHeader = "CommonQuestions-module--section-header--367a4";
export var stillNeedHelpSection = "CommonQuestions-module--still-need-help-section--94ea3";
export var tabSection = "CommonQuestions-module--tab-section--252dc";
export var tabSelected = "CommonQuestions-module--tab-selected--8156b";
export var tabs = "CommonQuestions-module--tabs--4200d";